import styled from 'styled-components';
import { Container } from 'reactstrap';
import { fontStyle, fontWeight, mediaBreakpointUp } from '@whitelabel/helpers/style';
import { HeadingBlock } from '@whitelabel/component-library';

const StyledFNOLHeadingBlock = styled(HeadingBlock)`
  h2 {
    margin-bottom: 0.5rem;
    font-weight: ${fontWeight('medium')};
    text-transform: none;
  }
  .lead {
    ${fontStyle('lead')}
  }
  ${fontStyle('h2')}
`;

const StyledFNOLSectionContainer = styled(Container)`
  /* based on 8 col layout design by chris shorturl.at/bcpvU  */
  ${mediaBreakpointUp('md')`
    max-width: 806px;
  `}
`;

export { StyledFNOLHeadingBlock, StyledFNOLSectionContainer };
